const translations = {
    header: '{{fileCount}} Files'
};

export default translations;
